/**
 * Search Service — Semantic Content Search for governance-suite
 *
 * Story BL-045.3: Semantic Content Search (AC7)
 *
 * Fetches proposal search results from oracle-bridge semantic search endpoint.
 * Uses getApiBaseUrl() pattern from apiHelpers.ts.
 * Never throws — returns empty results on error for graceful degradation.
 */

import { authenticatedFetch } from '@hello-world-dao/auth';
import { getApiBaseUrl } from './apiHelpers';

export interface SearchResult {
  id: number;
  type: 'blog' | 'proposal';
  title: string;
  excerpt: string;
  score: number | null;
  url: string;
}

export interface SearchResponse {
  results: SearchResult[];
  semantic: boolean;
}

/**
 * Perform semantic search for proposals via oracle-bridge.
 *
 * @param q - Search query string (min 2 chars)
 * @returns SearchResponse — never throws, returns empty results on error
 */
export async function semanticSearch(
  q: string,
  type: 'proposal' | 'blog' | 'all' = 'proposal',
): Promise<SearchResponse> {
  const base = getApiBaseUrl();
  const params = new URLSearchParams({ q, type });

  try {
    const response = await authenticatedFetch(`${base}/api/search?${params}`, {
      method: 'GET',
    });
    if (!response.ok) return { results: [], semantic: false };
    return response.json() as Promise<SearchResponse>;
  } catch {
    return { results: [], semantic: false };
  }
}
